<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" (click)="picker.open()">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
  </mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    [(ngModel)]="value"
    [required]="isRequiredControl"
    [disabled]="isDisabled"
    [errorStateMatcher]="this"
    spellcheck="false"
    autocomplete="off"
  />
  @if (!isDisabled && value && removable) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }
  @if (!isDisabled) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CALENDAR_LIGHT" (click)="picker.open()"></i>
  }
  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  <mat-datepicker #picker [calendarHeaderComponent]="header"></mat-datepicker>
  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
</mat-form-field>
